/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import likeliHoodImpact from '../../../assets/Images/svg/likeliHood/likelihood-impact-img.svg';
import HistoryDrawer from '../RiskRegisterHistory/HistoryDrawer';
import Moment from 'moment';

export default function RiskRegisterFormView({ detail }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [visible, setVisible] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);

    const location = useLocation();
    const { options, subOption, riskInfo } = location?.state;

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
            <div
                className="flex justify-between "
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                <div className="text-2xl font-semibold pb-2 text-purple">
                    {t('RR.RiskFactors')} :{' '}
                    {subOption?.riskFactorSubOptionName
                        ? subOption?.riskFactorSubOptionName
                        : options?.riskFactorOptionName || '-'}
                </div>
                <div className="flex space-x-3 justify-center items-center mb-2">
                    <span className="inline-block text-sm align-middle">
                        {t('Version')} : {riskInfo?.version || '0000'}
                    </span>
                    <button
                        onClick={(e) => {
                            setVisible(true);
                        }}
                        className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                    >
                        <ClockCircleOutlined />
                    </button>
                    <Drawer
                        title={
                            <div className="flex justify-between items-center">
                                <span className="text-purple text-[17px]">
                                    {t('History')}
                                </span>
                                <button
                                    onClick={(e) => {
                                        setIsChangeStatus(true);
                                        setVisible(false);
                                    }}
                                    className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                                >
                                    <CloseOutlined />
                                </button>
                            </div>
                        }
                        placement="right"
                        onClose={() => setVisible(false)}
                        closable={false}
                        open={visible}
                        className="history"
                    >
                        <HistoryDrawer
                            isChangeStatus={isChangeStatus}
                            setIsChangeStatus={setIsChangeStatus}
                        />
                    </Drawer>
                </div>
            </div>
            <div className="grid grid-cols-3 mt-5">
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.Cause')}
                    </div>
                    {detail?.causes || '-'}
                </div>
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.Consequence')}
                    </div>
                    {detail?.consequence || '-'}
                </div>
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.ProcedureOrWorkInstruction')}
                    </div>
                    {detail?.workInstruction || '-'}
                </div>
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.TypeOfImpact')}
                    </div>
                    {detail?.impactTypeName || '-'}
                </div>
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.ImpactLevel')}
                    </div>
                    {detail?.impactLevelName || '-'}
                </div>
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.Likelihood')}
                    </div>
                    {detail?.likelihoodName || '-'}
                </div>
                {detail?.score && (
                    <div className="col-span-2">
                        <div className="text-[20px] font-bold mb-2">
                            {t('RR.RiskAssessmentResults')}
                        </div>
                        <div
                            className={`p-3 rounded-md`}
                            style={{ background: detail?.riskLevelColor }}
                        >
                            <div className="text-sm text-white">
                                {t('RR.ResultingRiskScore')}{' '}
                            </div>
                            <div className="text-base font-semibold text-white">
                                {detail?.score} :{' '}
                                {lang === 'en'
                                    ? detail?.riskLevelNameEn
                                    : detail?.riskLevelNameTh}{' '}
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-span-2">
                    <div className="mt-5 mb-5">
                        <img src={likeliHoodImpact} alt="LikeliHood Impact" />
                    </div>
                </div>
                <div className="col-span-2 p-4 mb-4 box-content">
                    <div className="text-lg font-semibold text-purple mb-1">
                        {t('RR.WillYouAcceptRisk')}
                    </div>
                    {detail ? (
                        detail?.acceptTheRisk === true ? (
                            <>&#8226; {t('RR.AcceptRisk')}</>
                        ) : (
                            <>&#8226; {t('RR.NotAcceptRisk')}</>
                        )
                    ) : (
                        <>-</>
                    )}
                </div>
                {detail?.acceptTheRisk === false && (
                    <>
                        <div className="col-span-2 p-4 mb-4 box-content">
                            <div className="text-lg font-semibold text-purple mb-1">
                                {t('RR.Todo')}
                            </div>
                            &#8226; {detail?.todo ? detail?.todo : '-'}
                        </div>
                        <div className="col-span-2 p-4 mb-4 box-content">
                            <div className="text-lg font-semibold text-purple mb-1">
                                {t('RR.DatePlan')}
                            </div>
                            &#8226;{' '}
                            {detail?.startDate
                                ? `${Moment(detail?.startDate).format(
                                      'DD/MM/YYYY'
                                  )} - ${Moment(detail?.endDate).format(
                                      'DD/MM/YYYY'
                                  )}`
                                : '-' || '-'}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
